import script from "./slider-check.vue?vue&type=script&setup=true&lang=js"
export * from "./slider-check.vue?vue&type=script&setup=true&lang=js"

import "./slider-check.vue?vue&type=style&index=0&id=065bbf28&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dslx464\\Desktop\\workspace\\chatgpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065bbf28"]])

export default __exports__